/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Badge_Pricedrop1Inputs */

const he_item_stats_badge_pricedrop1 = /** @type {(inputs: Item_Stats_Badge_Pricedrop1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ירידת מחיר`)
};

const en_item_stats_badge_pricedrop1 = /** @type {(inputs: Item_Stats_Badge_Pricedrop1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price drop`)
};

/**
* | output |
* | --- |
* | "Price drop" |
*
* @param {Item_Stats_Badge_Pricedrop1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_badge_pricedrop1 = /** @type {((inputs?: Item_Stats_Badge_Pricedrop1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Badge_Pricedrop1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_badge_pricedrop1(inputs)
	return en_item_stats_badge_pricedrop1(inputs)
});
export { item_stats_badge_pricedrop1 as "item_stats_badge_priceDrop" }